import type { EmbedResourceParameter } from "metabase/public/lib/types";

import type { ExternalProxyRule, ExternalProxyRuleParams } from "./api";

const hasMeaningfulRuleParamValue = (value: unknown) => {
  if (Array.isArray(value)) {
    return value.some(
      (item) =>
        item != null && (typeof item !== "string" || item.trim().length > 0),
    );
  }

  return (
    value != null && (typeof value !== "string" || value.trim().length > 0)
  );
};

export const sanitizeRuleParams = (
  params: ExternalProxyRule["params"],
  lockedParameters: EmbedResourceParameter[],
): ExternalProxyRuleParams =>
  Object.fromEntries(
    lockedParameters.flatMap((parameter) =>
      params &&
      Object.prototype.hasOwnProperty.call(params, parameter.slug) &&
      hasMeaningfulRuleParamValue(params[parameter.slug])
        ? [[parameter.slug, params[parameter.slug]]]
        : [],
    ),
  );

export const normalizeRuleForForm = (
  rule: ExternalProxyRule,
  lockedParameters: EmbedResourceParameter[],
): ExternalProxyRule => ({
  ...rule,
  params: sanitizeRuleParams(rule.params, lockedParameters),
});

export const sanitizeRulesForLockedParameters = (
  rules: ExternalProxyRule[],
  lockedParameters: EmbedResourceParameter[],
): ExternalProxyRule[] =>
  rules.map((rule) => ({
    ...rule,
    params: sanitizeRuleParams(rule.params, lockedParameters),
  }));

export const getRuleFormValuesByParameterId = (
  params: ExternalProxyRule["params"],
  lockedParameters: EmbedResourceParameter[],
): ExternalProxyRuleParams =>
  Object.fromEntries(
    lockedParameters.flatMap((parameter) =>
      params && Object.prototype.hasOwnProperty.call(params, parameter.slug)
        ? [[parameter.id, params[parameter.slug]]]
        : [],
    ),
  );

export const getCombinedRuleEmails = (rules: ExternalProxyRule[]): string =>
  rules
    .map((rule) => rule.email?.trim())
    .filter(Boolean)
    .join(", ");
